module.exports = __webpack_public_path__ + "static/media/flood_1.af9673d9.png";